@use '../@shared/mixins' as *;
@use '../@shared/global' as *;
@use '../tooltip/style.scss' as *;
@use '../@shared/icon.mixin' as *;
@use '../@shared/popover-button.mixin' as *;

@layer kol-component {
	@include kol-icon-styles();
	@include kol-popover-button-styles;

	.kol-split-button {
		display: flex;
		position: relative;
		width: 100%;
		&__root {
			display: flex;
			position: relative;
			width: 100%;
			align-items: stretch;
		}
		&__button {
			min-width: 0;
			flex: 1 1 auto;
			text-align: left;
		}
	}
}
